import { Route } from '@angular/router';
import {TenderContractDashboardIndexAnalysisYearsComponent} from '../../../../../../../../pages';

export const yearOnYearRoute: Route = {
    path: 'year-on-year',
    component: TenderContractDashboardIndexAnalysisYearsComponent,
};
